import { Button, Container, SectionTitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import googleIcon from './assets/google-icon.svg';
import * as Styled from './styled';
import type { AgendaConfigPageProps } from './types';

export * from './types';

export const AgendaConfigPage: FC<AgendaConfigPageProps> = (props) => {
  const { href } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper>
      <Container>
        <Styled.StyledCard size="small">
          <SectionTitle>{translate('agendaConfig.title')}</SectionTitle>
          <a target="_blank" href={href} rel="noreferrer" className="a-reset">
            <Button color="white" outlined shrink>
              <Styled.SsoButtonIconWrapper>
                <img src={googleIcon} alt="" />
              </Styled.SsoButtonIconWrapper>
              {translate('common.buttons.sync')}
            </Button>
          </a>
        </Styled.StyledCard>
      </Container>
    </Styled.Wrapper>
  );
};
